<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-03-07 10:30:50
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\top.vue
-->
<template>
    <div class="top_back_div">
        <div class="top_div">
            <div class="top_div_left_area">
                <div class="top_left_div">
                    <span>嗨,</span>
                    <span>欢迎&nbsp;</span>
                    <a class="mainFontColor" v-if="!loginName" @click="toLogin(1)">登录&nbsp;</a>
                    <span class="mainFontColor" v-if="loginName" @click="toPersonalPage">{{ loginName }}&nbsp;</span>
                    <a class="mainFontColor" v-if="!loginName" @click="toLogin(2)">注册&nbsp;</a>
                    <div style="width:200px;display: flex;">生科云选<img style="width: 10px;height: 10px;" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/login/indexR1.png" alt="" srcset=""></img>供应链</div>
                    <span class="mainFontColor" style="margin-left: 10px" v-if="loginName" @click="backLogin">退出</span>
                </div>
            </div>
            <div class="top_div_right_area">
                <div class="top_right_div">
                    <el-row type="flex" justify="end">
                        <el-col :span="4" style="text-align: right">
                            <router-link :to="{ path: '/', query: {} }"><span class="strokeDiv">首页</span></router-link>
                        </el-col>
                        <el-col :span="5" style="text-align: right">
                            <router-link :to="{ path: '/personal/myOrder', query: {} }"><span class="strokeDiv">我的订单</span></router-link>
                        </el-col>
                        <el-col :span="5" style="text-align: right">
                            <router-link :to="{ path: '/personal/collection_list', query: {} }"><span class="strokeDiv">收藏夹</span></router-link>
                        </el-col>
                        <el-col :span="5" style="text-align: right">
                            <router-link :to="{ path: '/personal', query: {} }"><span class="strokeDiv">个人中心</span></router-link>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="address_popup" v-if="isSelectAddress">
            <div class="address_center">
                <div class="address_tips">选择地址</div>
                <div class="address_select">
                    <div class="address_select_title">
                        <div class="address_select_title_items on">
                            <span class="address_title_citys">{{
                province || "请选择"
              }}</span>
                            <img class="arrow_bottom" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/arrow_bottom_c7.png" alt="" />
                        </div>
                        <div class="address_select_title_items">
                            <span class="address_title_citys">{{ city || "请选择" }}</span>
                            <img class="arrow_bottom" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/arrow_bottom_c7.png" alt="" />
                        </div>
                    </div>
                    <div class="address_select_content">
                        <div class="address_select_content_items onSelect">
                            <span class="address_items" v-for="item in options" :key="item.value" @click="choosedProvince(item)">{{ item.label }}</span>
                        </div>
                        <div class="address_select_content_items">
                            <span class="address_items" v-for="items in cityOptions" :key="items.value" @click="choosedCity(items)">{{ items.label }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from "@/store";
import $ from "jquery";
import { url_origin } from "@/utils/commonValue";
import { getIndexCategoryTreeData } from "@/api/common/categoryApi";
import { getCascadeRegionData } from "@/api/common/regionApi";
import { logout } from "@/api/passport/passportApi";
import { getCustomerInfoData } from "@/api/customer/customerApi";
import { loginOut } from "@/utils/auth";
let id = 0;
export default {
    inject: ["reload"], //注入强制刷新依赖
    data() {
        return {
            options: [],
            province: store.state.province.name,
            city: store.state.city.name,
            isSelectAddress: false,
            isShowQR_code: false,
            categoryList: [],
            cityOptions: [],
        };
    },
    props: {
        customer: {
            type: Object,
            default: function () {
                return {
                    isAllowChild: false,
                };
            },
        },
    },
    computed: {
        loginName: function () {
            return store.getters.getUserName;
        },
        provinceId: function () {
            return store.state.province.id;
        },
        cityId: function () {
            return store.state.city.id;
        },
    },
    created() {
        const token = store.getters.getToken;
        if (token) {
            this.getCustomerInfo();
        }
        this.getIndexCategoryTree();
    },
    mounted() {},
    methods: {
        getCustomerInfo: function () {
            getCustomerInfoData().then((res) => {
                if (res.success) {
                    this.customer.isAllowChild = res.data.isAllowChildAccount;
                    this.customer.fullName = res.data.fullName;
                }
            });
        },
        goroute() {
            this.$router.push({ path: "/cart/ruzhu" });
        },
        golist() {
            this.$router.push({ path: "/cart/copm" });
        },
        getIndexCategoryTree() {
            getIndexCategoryTreeData().then((res) => {
                this.categoryList = res.data;
            });
        },
        //退出登录
        backLogin() {
            logout().then((res) => {
                loginOut();
                this.$router.push({ path: "/passport/login" });
            });
        },
        showQRCode() {
            this.isShowQR_code = true;
        },
        hideQRCode() {
            this.isShowQR_code = false;
        },
        toPersonalPage() {
            this.$router.push({ path: "/personal" });
        },
        toLogin(index) {
            if (index == 1) {
                sessionStorage.setItem("isLogin", true);
                this.$router.push({ path: "/passport/login" });
            } else {
                sessionStorage.setItem("isLogin", false);
                this.$router.push({ path: "/passport/register" });
            }
        },
    },
};
</script>
<style scoped>
.top_back_div {
    width: 100%;
    min-width: 1200px;
    height: 30px;
    background: #f8f8f8;
    text-align: center;
}

.top_div {
    width: 1200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
}
.top_div_left_area {
    display: flex;
}
.top_div_right_area {
    display: flex;
}
.choose_address {
    min-width: 130px;
    display: flex;
    align-items: center;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 30px;
}
.top_left_div {
    min-width: 270px;
    height: 30px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: left;
    margin-top: 20px;
    /* line-height: 20px; */
    display: flex;
}
.top_left_div span {
    cursor: pointer;
}
.top_right_div {
    width: 495px;
    height: 30px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    text-align: right;
    margin-left: 10px;
}
.mainFontColor {
    cursor: pointer;
}
/* 手机商城、二维码 */
.QR_code {
    width: 132px;
    height: 140px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 30px;
    right: 310px;
    z-index: 9;
}
.QR_code img {
    width: 94px;
    height: 94px;
}
.QR_code_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 23px;
}
.phone {
    text-align: center;
}
.live {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pageComponents/top.vue